import { gableSubRoofExtrusionAABB3 } from "building-generation/elements/roofs";
import type {
  RoofVolumeGenerationStageInput,
  RoofVolumeGenerationStageResult,
} from "building-types/roofVolumes/roofVolumeGenerationTypes";
import { makeGableRoofExtrusion } from "../../roofTools/gableRoofExtrusion";

/**
 * Generates the roof main geometry using the roof vertical rails as input
 */
export function generateRoofVolumeExtrusion({
  roofVolumeOptions,
  roofVolume,
}: RoofVolumeGenerationStageInput): RoofVolumeGenerationStageResult {
  const { rails2D, verticalRails, extensions, shedRoofHalfFace, startConnectivity, endConnectivity } = roofVolume;
  const { peakRail } = rails2D;
  const { insertedRoofVolumes, neighborRoofs } = roofVolumeOptions;
  const { startNeighbor, endNeighbor } = neighborRoofs;
  const { hasStartExtension, hasEndExtension } = extensions;

  const startNeighborRoof = insertedRoofVolumes[startNeighbor.roofId];
  const endNeighborRoof = insertedRoofVolumes[endNeighbor.roofId];

  const { hasPartialOverlap: hasStartPartialOverlap } = startConnectivity;
  const { hasPartialOverlap: hasEndPartialOverlap } = endConnectivity;

  const isRoofConnected = (isEnd: boolean): boolean => {
    const endFace = isEnd ? extrusion.endFace : extrusion.startFace;
    const connectivity = isEnd ? endConnectivity : startConnectivity;
    const { isFree } = connectivity;

    return !endFace || !isFree;
  };

  // generate extrusion
  const extrusion = makeGableRoofExtrusion({
    peakRail,
    verticalRails,
    hasStartExtension,
    hasEndExtension,
    shedRoofClipPlane: shedRoofHalfFace?.plane,
    startOffsetV:
      startNeighborRoof && hasStartExtension && !hasStartPartialOverlap ? startNeighborRoof.extrusion.peakTextureV : 0,
    endOffsetV:
      endNeighborRoof && hasEndExtension && !hasEndPartialOverlap ? endNeighborRoof.extrusion.peakTextureV : 0,
  });

  const isRoofConnectedAtStart = isRoofConnected(false);
  const isRoofConnectedAtEnd = isRoofConnected(true);

  return {
    roofVolume: {
      extrusion,
      isRoofConnectedAtStart,
      isRoofConnectedAtEnd,
      aabb3: gableSubRoofExtrusionAABB3(extrusion),
    },
  };
}
